var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "preview" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-6" },
        [
          _c("prism-editor", {
            staticClass: "my-editor",
            attrs: {
              id: "code-editor",
              highlight: _vm.highlighter,
              "line-numbers": ""
            },
            on: { input: _vm.input },
            model: {
              value: _vm.valueMutable,
              callback: function($$v) {
                _vm.valueMutable = $$v
              },
              expression: "valueMutable"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-12 col-md-6" }, [
        _c("iframe", {
          attrs: { src: "data:text/html;charset=utf-8," + _vm.renderValue }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }